// `video.frames`: four frames of a video as JPEGs, what Yapper Ad's picture check reads of a take
// (spec G14-yapper-ad), the worker's own ffmpeg. Live draws them in its browser and lists no such
// job; a template's run starts it.
import { VideoFramesQuote, VideoFramesRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.frames"> = {
  type: "video.frames",
  label: "Video frames",
  source: "form",
  pair: "video.frames",
  fields: () => ({}),
  request: VideoFramesRequest,
  quote: VideoFramesQuote,
};
